<template>
    <div class="dvw-uploader">
        <!-- Ручной ввод матча -->
        <div class="manual-match-section">
            <button @click="showManualMatchForm = !showManualMatchForm" class="toggle-btn">
                {{ showManualMatchForm ? '✕ Скрыть' : '+ Занести матч вручную' }}
            </button>

            <div v-if="showManualMatchForm" class="manual-match-form">
                <!-- Выбор матча или создание нового -->
                <div class="form-group">
                    <label>
                        <input type="radio" v-model="manualMatchForm.create_new" :value="true" />
                        Создать новый матч
                    </label>
                    <label>
                        <input type="radio" v-model="manualMatchForm.create_new" :value="false" />
                        Выбрать существующий матч
                    </label>
                </div>

                <!-- Выбор существующего матча -->
                <div v-if="!manualMatchForm.create_new" class="form-group">
                    <label>Матч <span class="required">*</span></label>
                    <UiSelect v-model="manualMatchForm.match_id" label="" :options="matchOptions" value-type="number"
                        block placeholder="Выберите матч" />
                </div>

                <!-- Поля для нового матча (необязательно) -->
                <template v-if="manualMatchForm.create_new">
                    <div class="form-row">
                        <div class="form-group">
                            <label>Команда хозяев</label>
                            <UiSelect v-model="manualMatchForm.home_team_id" label="" :options="teamOptions"
                                value-type="number" block placeholder="Выберите команду" />
                        </div>
                        <div class="form-group">
                            <label>Команда гостей</label>
                            <UiSelect v-model="manualMatchForm.away_team_id" label="" :options="teamOptions"
                                value-type="number" block placeholder="Выберите команду" />
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label>Дата матча</label>
                            <UiInput v-model="manualMatchForm.match_date" type="date" label="" block />
                        </div>
                        <div class="form-group">
                            <label>Время</label>
                            <UiInput v-model="manualMatchForm.match_time" type="time" label="" block />
                        </div>
                        <div class="form-group">
                            <label>Сезон</label>
                            <UiInput v-model="manualMatchForm.season" label="" block placeholder="2024-2025" />
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label>Этап</label>
                            <UiSelect v-model="manualMatchForm.stage" label="" :options="stageOptions"
                                value-type="string" block />
                        </div>
                        <div class="form-group">
                            <label>Номер тура</label>
                            <UiInput v-model="manualMatchForm.tour_number" type="number" label="" block min="1" />
                        </div>
                        <div class="form-group">
                            <label>Номер матча</label>
                            <UiInput v-model="manualMatchForm.match_number" type="number" label="" block min="1" />
                        </div>
                    </div>
                </template>

                <!-- Обязательные поля: счет в сетах -->
                <div class="form-row">
                    <div class="form-group">
                        <label>Счет в сетах (хозяева) <span class="required">*</span></label>
                        <UiInput v-model.number="manualMatchForm.home_score" type="number" label="" block min="0" max="3" required />
                    </div>
                    <div class="form-group">
                        <label>Счет в сетах (гости) <span class="required">*</span></label>
                        <UiInput v-model.number="manualMatchForm.away_score" type="number" label="" block min="0" max="3" required />
                    </div>
                </div>

                <!-- Обязательные поля: счет в партиях -->
                <div class="form-group">
                    <label>Счет в партиях <span class="required">*</span></label>
                    <div class="sets-score-list">
                        <div v-for="(set, index) in manualMatchForm.sets_score" :key="index" class="set-score-row">
                            <span class="set-number">Сет {{ index + 1 }}</span>
                            <UiInput v-model.number="set.home" type="number" label="" class="set-input" min="0" placeholder="Хозяева" required />
                            <span class="set-separator">:</span>
                            <UiInput v-model.number="set.away" type="number" label="" class="set-input" min="0" placeholder="Гости" required />
                            <button v-if="manualMatchForm.sets_score.length > 1" @click="removeSet(index)" type="button" class="remove-set-btn">✕</button>
                        </div>
                        <button @click="addSet" type="button" class="add-set-btn">+ Добавить сет</button>
                    </div>
                </div>

                <!-- Опция: Техническое поражение -->
                <div class="form-group">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="manualMatchForm.is_technical_defeat" @change="applyTechnicalDefeat" />
                        <span>Техническое поражение</span>
                    </label>
                    <div v-if="manualMatchForm.is_technical_defeat" class="form-group" style="margin-top: 10px;">
                        <label>Команда, которой поражение</label>
                        <UiSelect v-model="manualMatchForm.technical_defeat_winner" label="" :options="winnerOptions"
                            value-type="string" block @change="applyTechnicalDefeat" />
                    </div>
                </div>

                <button @click="createManualMatch"
                    :disabled="creatingManualMatch"
                    class="submit-btn manual-match-btn">
                    {{ creatingManualMatch ? 'Сохранение...' : 'Сохранить матч' }}
                </button>
            </div>
        </div>

        <!-- Техническое поражение (старая форма - для совместимости) -->
        <div class="technical-defeat-section">
            <button @click="showTechnicalDefeatForm = !showTechnicalDefeatForm" class="toggle-btn">
                {{ showTechnicalDefeatForm ? '✕ Скрыть' : '+ Техническое поражение (старая форма)' }}
            </button>

            <div v-if="showTechnicalDefeatForm" class="technical-defeat-form">
                <div class="form-group">
                    <label>Матч</label>
                    <UiSelect v-model="technicalDefeatForm.match_id" label="" :options="matchOptions"
                        value-type="number" block placeholder="Выберите матч" />
                </div>

                <div class="form-group">
                    <label>Команда, которой поражение</label>
                    <UiSelect v-model="technicalDefeatForm.winner" label="" :options="winnerOptions"
                        value-type="string" block />
                </div>

                <button @click="createTechnicalDefeat"
                    :disabled="creatingTechnicalDefeat || !technicalDefeatForm.match_id"
                    class="submit-btn technical-defeat-btn">
                    {{ creatingTechnicalDefeat ? 'Назначение...' : 'Назначить техническое поражение' }}
                </button>
            </div>
        </div>

        <!-- File Drop Zone -->
        <div class="drop-zone" :class="{ active: dragActive, 'has-files': files.length > 0 }"
            @dragover.prevent="dragActive = true" @dragleave="dragActive = false" @drop="handleDrop">
            <input type="file" accept=".dvw" multiple @change="handleFileChange" class="file-input" id="dvw-file" />
            <label for="dvw-file" class="drop-label">
                <div class="drop-icon">📊</div>
                <div v-if="files.length > 0" class="file-count">
                    {{ files.length }} файл(ов) выбрано
                </div>
                <div v-else>
                    <p class="drop-text">Перетащите DVW файлы сюда</p>
                    <p class="drop-hint">или нажмите для выбора (можно несколько)</p>
                </div>
            </label>
        </div>

        <!-- Files List -->
        <div v-if="files.length > 0" class="files-list">
            <div class="files-header">
                <h3>Файлы для загрузки</h3>
                <button v-if="files.some(f => f.status === 'success')" @click="clearCompleted" class="clear-btn">
                    Очистить загруженные
                </button>
            </div>

            <div v-for="fileEntry in files" :key="fileEntry.id" class="file-card" :class="fileEntry.status">
                <div class="file-header">
                    <div class="file-info">
                        <span class="file-name">{{ fileEntry.file.name }}</span>
                        <span v-if="fileEntry.status === 'success'" class="status-badge success">✓ Загружено</span>
                        <span v-else-if="fileEntry.status === 'error'" class="status-badge error">✗ Ошибка</span>
                        <span v-else-if="fileEntry.status === 'uploading'" class="status-badge uploading">⏳
                            Загрузка...</span>
                    </div>
                    <button v-if="fileEntry.status !== 'uploading'" @click="removeFile(fileEntry.id)"
                        class="remove-btn">✕</button>
                </div>

                <div v-if="fileEntry.error" class="error-message">
                    {{ fileEntry.error }}
                </div>

                <div v-if="fileEntry.previewLoading" class="preview-loading">
                    Анализ файла...
                </div>

                <div v-else-if="fileEntry.preview && fileEntry.status !== 'success'" class="file-details">
                    <!-- Инфо: в DVW порядок хозяин/гость обратный — при загрузке выровняем по БД -->
                    <div v-if="fileEntry.preview.teams_match && fileEntry.preview.teams_match.swapped"
                        class="teams-mismatch-warning">
                        <div class="warning-icon">ℹ️</div>
                        <div class="warning-content">
                            <strong>В файле хозяин и гость перепутаны</strong>
                            <div class="teams-comparison">
                                <div>В файле: {{ fileEntry.preview.teams_match.dvw_team1 }} vs {{ fileEntry.preview.teams_match.dvw_team2 }}</div>
                                <div>В БД: {{ fileEntry.preview.teams_match.db_home }} (хозяева) vs {{ fileEntry.preview.teams_match.db_away }} (гости)</div>
                            </div>
                            <p class="warning-hint">При загрузке порядок автоматически выровняется по матчу в БД.</p>
                        </div>
                    </div>

                    <div class="preview-info">
                        <span v-if="fileEntry.preview.match">{{ fileEntry.preview.match.date }}</span>
                        <span v-if="fileEntry.preview.teams">{{ fileEntry.preview.teams[0]?.name }} vs {{ fileEntry.preview.teams[1]?.name }}</span>
                        <span v-if="fileEntry.preview.actions_count">{{ fileEntry.preview.actions_count }} действий</span>
                        <span v-if="fileEntry.preview.matched_game_id" class="auto-matched">✓ Матч найден</span>
                    </div>

                    <div class="match-options">
                        <label class="checkbox-label">
                            <input type="checkbox" v-model="fileEntry.create_match" />
                            <span>Создать новый матч</span>
                        </label>

                        <div v-if="!fileEntry.create_match" class="form-group">
                            <UiSelect v-model="fileEntry.match_id" label="" :options="matchOptions" value-type="number"
                                block placeholder="Выберите матч" />
                        </div>

                        <div v-else class="teams-selection">
                            <UiSelect v-model="fileEntry.home_team_id" label="" :options="teamOptions"
                                value-type="number" placeholder="Хозяева" />
                            <UiSelect v-model="fileEntry.away_team_id" label="" :options="teamOptions"
                                value-type="number" placeholder="Гости" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button v-if="files.length > 0" @click="submit" class="submit-btn" :disabled="!canSubmit">
            {{uploading ? 'Загрузка...' : `Загрузить ${files.filter(f => f.status !== 'success').length} файл(ов)`}}
        </button>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';
import UiInput from '@/components/ui/forms/UiInput.vue';
import UiSelect from '@/components/ui/forms/UiSelect.vue';

const props = defineProps({
    matches: {
        type: Array,
        required: true,
    },
    teams: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['upload-complete']);
const matchOptions = computed(() => props.matches.map((match) => ({ value: match.id, label: match.label })));
const teamOptions = computed(() => props.teams.map((team) => ({ value: team.id, label: team.name })));
const stageOptions = [
    { value: 'championship', label: 'Чемпионат' }, { value: 'cup', label: 'Кубок' },
    { value: 'playoff', label: 'Плейофф' }, { value: 'quarterfinal', label: 'Четвертьфинал' },
    { value: 'semifinal', label: 'Полуфинал' }, { value: 'final', label: 'Финал' },
];
const winnerOptions = [{ value: 'home', label: 'Хозяева' }, { value: 'away', label: 'Гости' }];

// Ручной ввод матча
const showManualMatchForm = ref(false);
const manualMatchForm = ref({
    match_id: '', // если выбран существующий матч
    create_new: true, // создание нового матча или выбор существующего
    // Для нового матча (необязательно)
    home_team_id: '',
    away_team_id: '',
    match_date: '',
    match_time: '17:00',
    season: '',
    stage: 'championship',
    tour_number: '',
    match_number: '',
    // Обязательные поля
    home_score: '',
    away_score: '',
    sets_score: [{ home: '', away: '' }], // массив сетов
    // Техническое поражение (опция)
    is_technical_defeat: false,
    technical_defeat_winner: 'home', // команда, которой поражение
});
const creatingManualMatch = ref(false);

// Техническое поражение (старая форма - оставляем для совместимости)
const showTechnicalDefeatForm = ref(false);
const technicalDefeatForm = ref({
    match_id: '',
    winner: 'home', // home или away
});
const creatingTechnicalDefeat = ref(false);

// Массив файлов с превью
const files = ref([]);
const dragActive = ref(false);
const uploading = ref(false);

const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files).filter(f => f.name.endsWith('.dvw'));
    addFiles(newFiles);
    e.target.value = ''; // reset input
};

const handleDrop = (e) => {
    e.preventDefault();
    dragActive.value = false;
    const newFiles = Array.from(e.dataTransfer.files).filter(f => f.name.endsWith('.dvw'));
    addFiles(newFiles);
};

const addFiles = (newFiles) => {
    for (const file of newFiles) {
        // Проверяем, не добавлен ли уже
        if (files.value.some(f => f.file.name === file.name)) continue;

        const fileEntry = {
            id: Date.now() + Math.random(),
            file,
            preview: null,
            previewLoading: true,
            create_match: true,
            match_id: '',
            home_team_id: '',
            away_team_id: '',
            status: 'pending', // pending, uploading, success, error
            error: null,
        };

        files.value.push(fileEntry);

        // Загружаем превью параллельно (не ждём)
        loadPreview(fileEntry);
    }
};

const removeFile = (id) => {
    files.value = files.value.filter(f => f.id !== id);
};

const loadPreview = async (fileEntry) => {
    const formData = new FormData();
    formData.append('dvw_file', fileEntry.file);

    try {
        const { data } = await axios.post('/admin/dvw/preview', formData);
        if (data.success) {
            // Находим индекс и обновляем через массив для реактивности
            const idx = files.value.findIndex(f => f.id === fileEntry.id);
            if (idx !== -1) {
                files.value[idx].preview = data.data;
                files.value[idx].previewLoading = false;

                // Автоматически выбираем найденный матч
                if (data.data.matched_game_id) {
                    files.value[idx].match_id = data.data.matched_game_id;
                    files.value[idx].create_match = false;
                }
            }
            return;
        }
    } catch (err) {
        console.error('Preview error:', err);
        const idx = files.value.findIndex(f => f.id === fileEntry.id);
        if (idx !== -1) {
            files.value[idx].error = err.response?.data?.message || 'Ошибка анализа файла';
            files.value[idx].previewLoading = false;
        }
        return;
    }

    // Fallback
    const idx = files.value.findIndex(f => f.id === fileEntry.id);
    if (idx !== -1) {
        files.value[idx].previewLoading = false;
    }
};

const canSubmit = computed(() => {
    return files.value.length > 0 &&
        files.value.every(f => !f.previewLoading) &&
        !uploading.value;
});

const submit = async () => {
    uploading.value = true;

    for (const fileEntry of files.value) {
        if (fileEntry.status === 'success') continue;

        fileEntry.status = 'uploading';
        fileEntry.error = null;

        const formData = new FormData();
        formData.append('dvw_file', fileEntry.file);
        formData.append('create_match', fileEntry.create_match ? '1' : '0');
        if (!fileEntry.create_match && fileEntry.match_id) {
            formData.append('match_id', fileEntry.match_id);
        }
        if (fileEntry.create_match) {
            formData.append('home_team_id', fileEntry.home_team_id);
            formData.append('away_team_id', fileEntry.away_team_id);
        }

        try {
            await axios.post('/admin/dvw/upload', formData);
            fileEntry.status = 'success';
        } catch (err) {
            fileEntry.status = 'error';
            fileEntry.error = err.response?.data?.errors?.dvw_file?.[0]
                || err.response?.data?.message
                || err.message
                || 'Ошибка загрузки';
        }
    }

    uploading.value = false;
    emit('upload-complete');
};

const clearCompleted = () => {
    files.value = files.value.filter(f => f.status !== 'success');
};

// Добавить сет
const addSet = () => {
    manualMatchForm.value.sets_score.push({ home: '', away: '' });
};

// Удалить сет
const removeSet = (index) => {
    if (manualMatchForm.value.sets_score.length > 1) {
        manualMatchForm.value.sets_score.splice(index, 1);
    }
};

// Применить техническое поражение
const applyTechnicalDefeat = () => {
    if (manualMatchForm.value.is_technical_defeat) {
        // Устанавливаем счет в сетах: 3:0 (победитель получает 3, проигравший 0)
        // technical_defeat_winner - команда, которой поражение (проигравший)
        if (manualMatchForm.value.technical_defeat_winner === 'home') {
            // Поражение хозяевам - гости выиграли 3:0
            manualMatchForm.value.home_score = 0;
            manualMatchForm.value.away_score = 3;
        } else {
            // Поражение гостям - хозяева выиграли 3:0
            manualMatchForm.value.home_score = 3;
            manualMatchForm.value.away_score = 0;
        }
        
        // Создаем 3 сета со счетом 25:0
        manualMatchForm.value.sets_score = [];
        for (let i = 0; i < 3; i++) {
            manualMatchForm.value.sets_score.push({
                home: manualMatchForm.value.technical_defeat_winner === 'home' ? 0 : 25,
                away: manualMatchForm.value.technical_defeat_winner === 'away' ? 0 : 25,
            });
        }
    } else {
        // Если техническое поражение отключено, очищаем счет (но не удаляем сеты)
        // Пользователь может вручную ввести счет
    }
};

// Создать/обновить матч вручную
const createManualMatch = async () => {
    // Валидация обязательных полей
    // Проверяем, что счет указан (включая 0 как валидное значение)
    if (manualMatchForm.value.home_score === '' || manualMatchForm.value.home_score === null || manualMatchForm.value.home_score === undefined) {
        alert('Укажите счет в сетах (хозяева)');
        return;
    }
    
    if (manualMatchForm.value.away_score === '' || manualMatchForm.value.away_score === null || manualMatchForm.value.away_score === undefined) {
        alert('Укажите счет в сетах (гости)');
        return;
    }

    if (!manualMatchForm.value.sets_score || manualMatchForm.value.sets_score.length === 0) {
        alert('Укажите счет в партиях');
        return;
    }

    // Проверяем, что все сеты заполнены (включая 0 как валидное значение)
    const emptySets = manualMatchForm.value.sets_score.some(set => 
        set.home === '' || set.home === null || set.home === undefined ||
        set.away === '' || set.away === null || set.away === undefined
    );
    if (emptySets) {
        alert('Заполните счет во всех партиях');
        return;
    }

    // Если создаем новый матч, проверяем команды
    if (manualMatchForm.value.create_new) {
        if (!manualMatchForm.value.home_team_id || !manualMatchForm.value.away_team_id) {
            alert('Выберите команды');
            return;
        }
    } else {
        // Если выбираем существующий матч
        if (!manualMatchForm.value.match_id) {
            alert('Выберите матч');
            return;
        }
    }

    creatingManualMatch.value = true;

    try {
        const formData = {
            ...manualMatchForm.value,
            sets_score: manualMatchForm.value.sets_score,
        };

        // Если не создаем новый матч, убираем поля для нового матча
        if (!formData.create_new) {
            delete formData.home_team_id;
            delete formData.away_team_id;
            delete formData.match_date;
            delete formData.match_time;
            delete formData.season;
            delete formData.stage;
            delete formData.tour_number;
            delete formData.match_number;
        }

        const { data } = await axios.post('/admin/dvw/manual-match', formData);

        if (data.success) {
            alert('Матч успешно сохранен!');
            // Сбрасываем форму
            manualMatchForm.value = {
                match_id: '',
                create_new: true,
                home_team_id: '',
                away_team_id: '',
                match_date: '',
                match_time: '17:00',
                season: '',
                stage: 'championship',
                tour_number: '',
                match_number: '',
                home_score: '',
                away_score: '',
                sets_score: [{ home: '', away: '' }],
                is_technical_defeat: false,
                technical_defeat_winner: 'home',
            };
            showManualMatchForm.value = false;
            // Обновляем страницу для обновления списка матчей
            window.location.reload();
        }
    } catch (err) {
        const errorMsg = err.response?.data?.message
            || err.response?.data?.errors
            || 'Ошибка сохранения матча';
        alert(typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg));
    } finally {
        creatingManualMatch.value = false;
    }
};

const createTechnicalDefeat = async () => {
    if (!technicalDefeatForm.value.match_id) {
        alert('Выберите матч');
        return;
    }

    creatingTechnicalDefeat.value = true;

    try {
        const { data } = await axios.post('/admin/dvw/technical-defeat', technicalDefeatForm.value);

        if (data.success) {
            alert('Техническое поражение успешно назначено!');
            // Сбрасываем форму
            technicalDefeatForm.value = {
                match_id: '',
                winner: 'home',
            };
            showTechnicalDefeatForm.value = false;
            // Обновляем страницу для обновления списка матчей
            window.location.reload();
        }
    } catch (err) {
        const errorMsg = err.response?.data?.message
            || err.response?.data?.errors
            || 'Ошибка назначения технического поражения';
        alert(typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg));
    } finally {
        creatingTechnicalDefeat.value = false;
    }
};
</script>

<style scoped>
.teams-mismatch-warning {
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.warning-icon {
    font-size: 24px;
    flex-shrink: 0;
}

.warning-content {
    flex: 1;
}

.warning-content strong {
    display: block;
    margin-bottom: 8px;
    color: #856404;
}

.teams-comparison {
    font-size: 13px;
    color: #856404;
    margin: 8px 0;
    line-height: 1.6;
}

.warning-hint {
    margin: 8px 0 0;
    font-size: 13px;
    color: #856404;
}
</style>
